import { RequestLeaveAction, RequestLeaveStatus } from "__generated__/graphql"

export const REQUEST_ACTION_LABELS: Record<RequestLeaveAction, string> = {
  [RequestLeaveAction.RequestLate]: "Xin đi muộn",
  [RequestLeaveAction.RequestLeave]: "Xin nghỉ phép",
  [RequestLeaveAction.RequestLeaveEarly]: "Xin về sớm",
  [RequestLeaveAction.RequestRemote]: "Xin remote",
}

export const REQUEST_STATUS_LABELS: Record<RequestLeaveStatus, string> = {
  [RequestLeaveStatus.Approved]: "Đã phê duyệt",
  [RequestLeaveStatus.AwaitingApproval]: "Đang chờ phê duyệt",
  [RequestLeaveStatus.Rejected]: "Đã từ chối",
}

export const REQUEST_STATUS_COLORS: Record<RequestLeaveStatus, "error" | "success" | "warning"> = {
  [RequestLeaveStatus.Approved]: "success",
  [RequestLeaveStatus.AwaitingApproval]: "warning",
  [RequestLeaveStatus.Rejected]: "error",
}
